window._ = require("lodash");
window.moment = require("moment");
window.qs = require("qs");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
const numeral = require("numeral");
numeral.register("locale", "id", {
    delimiters: {
        thousands: ".",
        decimal: ",",
    },
    abbreviations: {
        thousand: "ribu",
        million: "juta",
        billion: "milyar",
        trillion: "triliun",
    },
});
numeral.locale("id");
window.numeral = numeral;
